/**
 * 폼 구성요소로 제공 가능한 프로바이더 목록입니다.
 */
import form from "./providers/form";

const providers = {
    FORM: 'form',
};

const elements = {
    form,
};

export {providers, elements};
